// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const eventsName = 'events';
const eventName = 'event';

// Action Types: Get All Tools.
export const GET_EVENTS_START = 'GET_EVENTS_START';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILED = 'GET_EVENTS_FAILED';
export const GET_EVENTS_RESET = 'GET_EVENTS_RESET';

// Action Types: Get One EVENT.
export const GET_EVENT_START = 'GET_EVENT_START';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAILED = 'GET_EVENT_FAILED';
export const GET_EVENT_RESET = 'GET_EVENT_RESET';

// Action Types: Create EVENT.
export const CREATE_EVENT_START = 'CREATE_EVENT_START';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILED = 'CREATE_EVENT_FAILED';
export const CREATE_EVENT_RESET = 'CREATE_EVENT_RESET';

// Action Types: Update EVENT.
export const UPDATE_EVENT_START = 'UPDATE_EVENT_START';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILED = 'UPDATE_EVENT_FAILED';
export const UPDATE_EVENT_RESET = 'UPDATE_EVENT_RESET';

// Action Types: Delete EVENT.
export const DELETE_EVENT_START = 'DELETE_EVENT_START';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILED = 'DELETE_EVENT_FAILED';
export const DELETE_EVENT_RESET = 'DELETE_EVENT_RESET';

// Action Creators: Get All Tools.
const getEventsStart = (payload) => ({ type: GET_EVENTS_START, payload });
const getEventsSuccess = (payload) => ({ type: GET_EVENTS_SUCCESS, payload });
const getEventsFailed = (payload) => ({ type: GET_EVENTS_FAILED, payload });
const getEventsReset = () => ({ type: GET_EVENTS_RESET });

// Action Creators: Get One EVENT.
const getEventStart = (payload) => ({ type: GET_EVENT_START, payload });
const getEventSuccess = (payload) => ({ type: GET_EVENT_SUCCESS, payload });
const getEventFailed = (payload) => ({ type: GET_EVENT_FAILED, payload });
const getEventReset = () => ({ type: GET_EVENT_RESET });

// Action Creators: Create EVENT.
const createEventStart = (payload) => ({ type: CREATE_EVENT_START, payload });
const createEventSuccess = (payload) => ({ type: CREATE_EVENT_SUCCESS, payload });
const createEventFailed = (payload) => ({ type: CREATE_EVENT_FAILED, payload });
const createEventReset = () => ({ type: CREATE_EVENT_RESET });

// Action Creators: Update EVENT.
const updateEventStart = (payload) => ({ type: UPDATE_EVENT_START, payload });
const updateEventSuccess = (payload) => ({ type: UPDATE_EVENT_SUCCESS, payload });
const updateEventFailed = (payload) => ({ type: UPDATE_EVENT_FAILED, payload });
const updateEventReset = () => ({ type: UPDATE_EVENT_RESET });

// Action Creators: Delete EVENT.
const deleteEventStart = (payload) => ({ type: DELETE_EVENT_START, payload });
const deleteEventSuccess = (payload) => ({ type: DELETE_EVENT_SUCCESS, payload });
const deleteEventFailed = (payload) => ({ type: DELETE_EVENT_FAILED, payload });
const deleteEventReset = () => ({ type: DELETE_EVENT_RESET });

// Actions: Get All Events.
export const getEvents = (payload, options = {}) => {
  const { page, limit, pagination, name } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getEventsStart);

      const query = { page, limit, pagination, name, sort: '-eventPinned,-_id' };
      const result = await ApiClient.get('/events', { params: query });
      if (result.data?.success) {
        const { events } = result.data?.data;
        dispatchSuccess(dispatch, getEventsSuccess, events, eventsName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getEventsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getEventsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Events.
export const clearEvents = () => getEventsReset();

// Actions: Get One Event.
export const getEvent = (payload, options = {}) => {
  const { eventId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getEventStart);

      const result = await ApiClient.get(`/events/${eventId}`);
      if (result.data?.success) {
        const { event } = result.data?.data;
        dispatchSuccess(dispatch, getEventSuccess, event, eventName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getEventFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getEventFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One Event.
export const clearEvent = () => getEventReset();

// Actions: Create Event.
export const createEvent = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createEventStart);

      const { name, description, eventDate, eventLink, eventPinned } = payload;

      const result = await ApiClient.post(`/events`, { name, description, eventDate, eventLink, eventPinned });
      if (result.data?.success) {
        const { event } = result.data?.data;
        dispatchSuccess(dispatch, createEventSuccess, event, eventName);
        showSnackbar(dispatch, 'Event created successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createEventFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createEventFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created Event.
export const clearCreatedEvent = () => createEventReset();

// Actions: Update Event.
export const updateEvent = (payload, options = {}) => {
  const { eventId, name, description, eventDate, eventLink, eventPinned } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateEventStart);

      const result = await ApiClient.put(`/events/${eventId}`, {
        name,
        description,
        eventDate,
        eventLink,
        eventPinned,
      });
      if (result.data?.success) {
        const { event } = result.data?.data;
        dispatchSuccess(dispatch, updateEventSuccess, event, eventName);
        showSnackbar(dispatch, 'Event updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateEventFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateEventFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated Event.
export const clearUpdatedEvent = () => updateEventReset();

// Actions: Delete Event.
export const deleteEvent = (payload, options = {}) => {
  const { eventId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, deleteEventStart);

      const result = await ApiClient.delete(`/events/${eventId}`);
      if (result.data?.success) {
        const { event } = result.data?.data;
        dispatchSuccess(dispatch, deleteEventSuccess, event, eventName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, deleteEventFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, deleteEventFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Deleted Event.
export const clearDeletedEvent = () => deleteEventReset();
